import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HelperService } from '../helper/helper.service';
import { AirportListService } from '../airport/airport-list.service';
import { EnvironmentConfigService } from '../shared/environment-config.service';

@Injectable({
  providedIn: 'root'
})
export class PickupServiceService {


  // http://api.travelx.ai/api/getTimeSlots?storeid=8152&ondate=2019-7-28&key=qw1op5cv8j0d&pid=gmr&platform=web
  apiConfig = {
    baseUrl: 'https://api2.travelx.ai',
    // baseUrl: 'http://a.gmr.in',
    timeSlotPath: '/api/getTimeSlots',
    validationPath: '/api/getProductValidation'
  };
  /*
    storeid: 8152
    ondate: 2019-7-28
    key: qw1op5cv8j0d
    pid: gmr
    platform: web
   */
  apiParams: any;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    })
  };


  // tslint:disable-next-line: max-line-length
  // http://api.travelx.ai/api/getProductValidation?airportid=1&key=qw1op5cv8j0d&pid=gmr&platform=android&storeids=3252&locationids=5261%2C5262&ondate=2019-06-20

  constructor(private httpClient: HttpClient, private helperService: HelperService, private envService: EnvironmentConfigService) {
    this.initApiParams();
  }

  public get timeSlotServiceApi(): string {
    let finalRequestParams = { ...this.envService.getDefaultApiParams(), ...this.apiParams };
    // tslint:disable-next-line: max-line-length
    return this.timeSlotServiceApi = `${this.envService.getTimeSlotsApi()}?${this.helperService.serializeToGetParams(finalRequestParams)}`;
  }
  public set timeSlotServiceApi(value: string) {
  }
  public get validationServiceApi(): string {
    let finalRequestParams = { ...this.envService.getDefaultApiParams(), ...this.apiParams };
    // tslint:disable-next-line: max-line-length
    return this.validationServiceApi = `${this.envService.getProductValidationApi()}?${this.helperService.serializeToGetParams(finalRequestParams)}`;
  }
  public set validationServiceApi(value: string) {
  }


  initApiParams() {
    this.apiParams = {};
  }
  getTimeSlots(date: string, storeId, locationId) {
    this.apiParams.storeId = storeId;
    this.apiParams.ondate = date;
    this.apiParams.location_id = locationId;
    return this.httpClient.get<any>(this.timeSlotServiceApi);
  }

  validateCart(storeIds, locationIds, timeSlot, ondate, flightId?) {
    this.apiParams.storeids = storeIds;
    this.apiParams.locationids = locationIds;
    this.apiParams.ondate = ondate;
    this.apiParams.pickuptime = timeSlot;
    if (flightId) {
      this.apiParams.flightid = flightId;
    }
    return this.httpClient.get<any>(this.validationServiceApi);
  }
}
